import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ICONS, CONSTANT } from '../session/index';

@Component({
	//moduleId: module.id,
	selector: 'app-gridempty',
	templateUrl: 'gridempty.component.html',
	styleUrls: ['./gridempty.component.css']
})
export class GridEmptyComponent implements OnInit {
	@Output() onClickButtonEmpty: EventEmitter<any> = new EventEmitter();
	@Input() indAddButton: boolean;
	@Input() indNotDataFound: boolean;
	@Input() indNotResult: boolean;

	@Input() dataAddButton: any;
	@Input() msgNotDataFound: string;
	@Input() msgNotResult: string;

	constructor() {}

	ngOnInit() {
		if(!this.msgNotDataFound)
			this.msgNotDataFound = CONSTANT.msgNotDataFoundDefault;

		//this.dataAddButton = { icon: ICONS.new, nameButton: "NOMBRE DE BOTON" };
		//this.msgNotResult = "No existen movimientos del afiliado.";
	}

	onClickButton(event: any){
		this.onClickButtonEmpty.emit(event);
	}
}
